const sectionKeywords: Record<string, string[]> = {
  experience: [
    'experience', 'work experience', 'professional experience',
    'employment history', 'internships', 'job experience'
  ],
  education: [
    'education', 'academic background', 'educational background',
    'qualifications', 'academics', 'academic qualifications'
  ],
  projects: [
    'projects', 'personal projects', 'technical projects',
    'side projects', 'project experience'
  ],
  skills: [
    'skills', 'technical skills', 'programming skills',
    'toolset', 'tech stack', 'competencies'
  ],
  certifications: [
    'certifications', 'certificates', 'courses',
    'online courses', 'licenses'
  ],
  awards: [
    'awards', 'achievements', 'honors', 'recognitions'
  ],
  languages: [
    'languages', 'spoken languages', 'language proficiency'
  ],
  extras: [
    'interests', 'hobbies', 'extra-curricular', 'extracurricular activities',
    'other information'
  ]
};

const prettyTitles: Record<string, string> = {
  experience: 'Work Experience',
  education: 'Education',
  projects: 'Projects',
  skills: 'Technical Skills',
  certifications: 'Certifications',
  awards: 'Awards & Achievements',
  languages: 'Languages',
  extras: 'Other Information'
};

const detectSection = (line: string): string | null => {
  const lower = line.toLowerCase();
  for (const [section, keywords] of Object.entries(sectionKeywords)) {
    if (keywords.some(keyword => lower.includes(keyword))) {
      return section;
    }
  }
  return null;
};

export const convertToMarkdown = (rawResumeData: string): string => {
  const lines = rawResumeData.split('\n').map(line => line.trim()).filter(Boolean);

  let markdown = '';
  let currentSection = '';
  let buffer: string[] = [];

  const flushBuffer = () => {
    if (buffer.length) {
      markdown += buffer.join('\n') + '\n\n';
      buffer = [];
    }
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    const detected = detectSection(line);
    if (detected) {
      flushBuffer();
      currentSection = detected;
      markdown += `## ${prettyTitles[detected] || detected}\n\n`;
      continue;
    }

    // Section-specific formatting
    switch (currentSection) {
      case 'experience':
      case 'projects':
      case 'certifications':
      case 'awards': {
        if (line.startsWith('•')) {
          buffer.push(`- ${line.replace(/^•\s*/, '')}`);
        } else if (/^[A-Z].+\s-\s[A-Z]/.test(line)) {
          // Likely a title like "Company - Remote"
          flushBuffer();
          buffer.push(`### ${line}`);
        } else if (/\d{4}.*(Present|\d{4})/.test(line)) {
          buffer.push(`**${line}**`);
        } else if (/^Tech Stack/i.test(line)) {
          buffer.push(`**${line.replace(':', ':**')}`);
        } else {
          buffer.push(line);
        }
        break;
      }

      case 'education': {
        if (/^\d{4}\s*-\s*\d{4}/.test(line) || /Present/.test(line)) {
          buffer.push(`**${line}**`);
        } else {
          flushBuffer();
          buffer.push(`### ${line}`);
        }
        break;
      }

      case 'skills':
      case 'languages':
      case 'extras': {
        buffer.push(`- ${line}`);
        break;
      }

      default: {
        buffer.push(line);
      }
    }
  }

  flushBuffer();
  return markdown.trim();
};
